import {
  NotificationType,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import type { AppState } from '@/types'

const SymbolNotificationBadge = () => {
  const dispatch = useDispatch()

  const isSymbolSelected = useSelector<AppState, boolean>(
    ({ canvas }) => canvas.symbol.selectedSymbol !== null
  )

  const notifications = useSelector(
    (state: AppState) => state.notification.main
  )

  useEffect(() => {
    if (isSymbolSelected) {
      dispatch(
        notificationActionCreators.setNotification({
          type: NotificationType.SYMBOL_SELECTED,
        })
      )
    } else {
      const notification = notifications.find((item) => item.type === 'symbol')
      const notificationIndex = notifications.findIndex(
        (item) => item.type === 'symbol'
      )

      // @todo refactor
      if (notification && notification.type === 'symbol') {
        dispatch(
          notificationActionCreators.setClearNotification({
            toastContainerId: 'main',
            index: notificationIndex,
          })
        )
      }
    }
  }, [isSymbolSelected])

  return null
}

export default SymbolNotificationBadge
